import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/dap-badge/dap-badge.component.js'

const tagName = 'dap-ds-dap-badge'

/**
 * `dap-ds-dap-badge`
 * @summary A DÁP badge is a brand element showing the use of this system design library.
 * @element dap-ds-dap-badge
 * @title - Dap badge
 *
 * @slot - Description of badge
 * *
 * @csspart base - Main badge container
 * @csspart icon - Badge icon
 * @csspart text - Badge text
 *
 * @cssproperty --dds-badge-padding-sm - Custom padding for the small badge (default: var(--dds-spacing-200) var(--dds-spacing-300))
 * @cssproperty --dds-badge-padding-lg - Custom padding for the large badge (default: var(--dds-spacing-400))
 * @cssproperty --dds-badge-border-width - Custom border width for the badge (default: var(--dds-border-width-base))
 * @cssproperty --dds-badge-border-color - Custom border color for the badge (default: var(--dds-border-neutral-divider))
 * @cssproperty --dds-badge-border-radius - Custom border radius for the badge (default: var(--dds-radius-base))
 * @cssproperty --dds-badge-color - Custom text color for the badge (default: var(--dds-text-neutral-base))
 * @cssproperty --dds-badge-gap - Custom gap between icon and text (default: var(--dds-spacing-200))
 * @cssproperty --dds-badge-font-size-sm - Custom font size for the small badge (default: var(--dds-font-xs))
 * @cssproperty --dds-badge-font-size-lg - Custom font size for the large badge (default: var(--dds-font-xs))
 * @cssproperty --dds-badge-font-weight - Custom font weight for the badge (default: var(--dds-font-weight-medium))
 * @cssproperty --dds-badge-line-height - Custom line height for the badge (default: var(--dds-font-line-height-large))
 * @cssproperty --dds-badge-border-color-normal - Custom border color for the normal variant (default: var(--dds-transparent-black-medium))
 * @cssproperty --dds-badge-background-color-normal - Custom background color for the normal variant (default: var(--dds-background-brand-subtle))
 * @cssproperty --dds-badge-color-normal - Custom text color for the normal variant (default: var(--dds-text-brand-subtle))
 * @cssproperty --dds-badge-border-color-inverted - Custom border color for the inverted variant (default: var(--dds-transparent-white-medium))
 * @cssproperty --dds-badge-background-color-inverted - Custom background color for the inverted variant (default: var(--dds-background-brand-base-inverted))
 * @cssproperty --dds-badge-color-inverted - Custom text color for the inverted variant (default: var(--dds-text-neutral-inverted))
 *
 * @property { 'sm' | 'lg' } size - The size of the DÁP badge. Default is `sm`.
 * @property {string} sizeMap - Responsive size map (e.g. "md:lg").
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSDAPBadge',
})

export default reactWrapper
